module.exports = __webpack_public_path__ + "static/Gotham-Thin-d7c731db4239cb9391e06eaf8f806081.woff2";